import CustomerIndexPage from "./CustomerIndexPage";
export default CustomerIndexPage;
